import GoogleMapApiServerService from "~/lib/services/Server1/GoogleMapApiServerService";
import { convertSpacesToDashes } from "./StringHelper";
import { getPublicIp, getUserIpEnhanced } from "./getUserIp";
import type { IpLocationForSearchPath } from "./ipLocationSearchPathHelper";

export const getLocationVars = (res: google.maps.GeocoderResult[]) => {
  let city = "";
  let state_short = "";
  let state_long = "";
  let country = "";
  let country_short = "";
  let streetName = "";
  let searchOnLatLng = false;
  let administrative_area_level = false;
  let sublocality_level = false;

  if (!res || !res?.length) {
    return { state_short, state_long, city, country, country_short };
  }

  const r = res[0];
  r.address_components.forEach((ac) => {
    // City Mapping
    if (ac.types.includes("locality")) {
      city = ac.long_name;
    }

    if (!city && ac.types.includes("administrative_area_level_2"))
      administrative_area_level = true;
    if (!city && ac.types.includes("administrative_area_level_3"))
      administrative_area_level = true;
    if (!city && ac.types.includes("administrative_area_level_4"))
      administrative_area_level = true;

    if (!city && ac.types.includes("sublocality_level_1"))
      sublocality_level = true;
    if (!city && ac.types.includes("sublocality_level_2"))
      sublocality_level = true;

    if (!city && ac.types.includes("neighborhood")) sublocality_level = true;
    if (!city && ac.types.includes("colloquial_area")) sublocality_level = true;

    if (
      administrative_area_level === true ||
      !!city ||
      sublocality_level === true
    ) {
      searchOnLatLng = true;
    }

    //STATE
    if (ac.types.includes("administrative_area_level_1")) {
      state_short = ac.short_name;
      state_long = ac.long_name;
    }

    if (ac.types.includes("country")) {
      country = ac.long_name;
      country_short = ac.short_name.toLowerCase();
    }

    if (ac.types.includes("route")) {
      streetName = ac.long_name;
    }
  });

  if ((state_long || state_short) === city) {
    city = "";
  }

  if (!country && !country_short) {
    searchOnLatLng = true;
  }
  city = convertSpacesToDashes(city);
  state_long = convertSpacesToDashes(state_long);
  country = convertSpacesToDashes(country);
  streetName = convertSpacesToDashes(streetName);

  return {
    state_short,
    state_long,
    city,
    country,
    country_short,
    streetName,
    searchOnLatLng,
  };
};
export type IpLocationResponse = IpLocationForSearchPath & {
  country?: string;
};

export const fetchLocation = async (
  handleSelectLocation: (
    city: string,
    coords: { lat: number; lng: number } | null,
    ipLocation?: IpLocationResponse,
  ) => void,
) => {
  try {
    const ip = await getPublicIp();
    console.log("ip address from fetchLocation", ip);
    const response = (await GoogleMapApiServerService.getLocation(
      ip ?? undefined,
    )) as IpLocationResponse;
    const coords =
      response.lat != null && response.lon != null
        ? { lat: Number(response.lat), lng: Number(response.lon) }
        : null;
    const label = [response.city, response.country].filter(Boolean).join(", ");
    handleSelectLocation(label, coords, response);
  } catch (error) {
    console.error("Error fetching location:", error);
  }
};
export const fetchCurrentLocation = async (request: Request) => {
  const userIp = await getUserIpEnhanced(request);
  console.log("original userIp address", userIp);
  try {
    const response = await GoogleMapApiServerService.getLocation(userIp || undefined);
    return response
  } catch (error) {
    console.error("Error fetching location:", error);
  }
};

export const getLocationFromIp = async (userIp: string) => {
  const response = await GoogleMapApiServerService.getLocation(userIp || undefined);
  return response
}